import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { DeclarationsStepComponent } from "../../wizard/wizard-steps/declarations-step/declarations-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class DeclarationsStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = DeclarationsStepComponent;
  }
}
